import React, { useEffect, useState } from "react";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useDispatch, useSelector } from "react-redux";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import AddTypeColor from "./components/AddTypeColor";
import { read } from "Helpers/LocalStorage";
import {
  getAllTypeColor,
  setNameForSearchProfileTypeColor,
} from "Stores/actions";
import FormControl from "@material-ui/core/FormControl";
import { SELECTED_TYPE_COLOR } from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import Input from "Components/Input/Input";
import * as Icons from "react-bootstrap-icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useTheme } from "@material-ui/core/styles";

function TypeColorProfile() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    typeColorList,
    selectedDasteProfile,
    selectedTypeColor,
    profileTypeColorSearch,
  } = useSelector((state) => ({
    typeColorList: state.profile.typeColorList,
    selectedDasteProfile: state.profile.selectedDasteProfile,
    selectedTypeColor: state.profile.selectedTypeColor,
    profileTypeColorSearch: state.profile.profileTypeColorSearch,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(false);

  const handleChange = async (value) => {
    dispatch({
      type: SELECTED_TYPE_COLOR,
      selectedTypeColor: value,
    });
  };

  const setValue = (name, value) => {
    dispatch(setNameForSearchProfileTypeColor(value));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    await ongetAllTypeColor();
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    await ongetAllTypeColor(true);
  };

  useEffect(() => {
    (async () => {
      await ongetAllTypeColor();
    })();
  }, [selectedDasteProfile]);

  const ongetAllTypeColor = async (clear = false) => {
    try {
      if (selectedDasteProfile) {
        setLoading(true);
        let dataSearch = null;
        if (!clear && profileTypeColorSearch && profileTypeColorSearch !== "")
          dataSearch = { Name: profileTypeColorSearch };
        if (clear) dispatch(setNameForSearchProfileTypeColor(""));
        const params = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          IdGroupProfile: selectedDasteProfile.Id,
          ...dataSearch,
        };
        await dispatch(getAllTypeColor(params));
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="side-box">
        <div>
          <MuiIconButton
            title={<Translator id={"searchProfileTypeColor"} />}
            icon={<Icons.Search size={17} />}
            onClick={() => setSearch(!search)}
            className={`fix-size ${search ? "standby" : ""}`}
            disabled={!(selectedDasteProfile && typeColorList)}
          />
          <Translator id={"profileTypeColor"} />
        </div>
        <div>
          {selectedDasteProfile && typeColorList && (
            <>
              <AddTypeColor reGetOnBack={ongetAllTypeColor} />
            </>
          )}
        </div>
      </div>
      <div
        className={`search-box-sidebox ${search ? "show-mode" : "hide-mode"}`}
      >
        <Input
          setValue={setValue.bind(this)}
          name="search"
          value={profileTypeColorSearch}
          placeholder={t("searchProfileTypeColor")}
          type="search"
          onSearch={onSearch}
          onClearSearch={onClearSearch}
        />
      </div>
      {typeColorList && selectedTypeColor && (
        <FormControl component="fieldset" className="radioGroup sideBoxSm">
          <RadioGroup>
            {typeColorList.map((item) => {
              return (
                <div
                  className="d-flex justify-content-between"
                  key={item.IdTypeColor + item.IdColor}
                >
                  <FormControlLabel
                    value={`${item.IdTypeColor} - ${item.IdColor}`}
                    key={item.Id}
                    className={direction === "rtl" ? "text-right" : "text-left"}
                    control={
                      <Radio
                        checked={
                          selectedTypeColor.IdTypeColor === item.IdTypeColor &&
                          selectedTypeColor.IdColor === item.IdColor
                        }
                        className="mx-2"
                        onChange={() => handleChange(item)}
                      />
                    }
                    label={item.Name}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </FormControl>
      )}
    </>
  );
}

export default TypeColorProfile;
